(function ($) {
$('.masonry__grid').masonry()

$('.pledge__comment-toggle').on('change', function() {
$('.masonry__grid').masonry()
    
});


})(jQuery);